export default __webpack_public_path__ + "static/media/jerry_on.89cc0695.png";